// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ChartAxisLabel_axisLabel__1OF5f {\n  fill: var(--ambient-basePlus75);\n}\n", "",{"version":3,"sources":["webpack://node_modules/@energybox/react-ui-library/dist/components/ChartAxisLabel/ChartAxisLabel.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC","sourcesContent":[".axisLabel {\n  fill: var(--ambient-basePlus75);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"axisLabel": "ChartAxisLabel_axisLabel__1OF5f"
};
export default ___CSS_LOADER_EXPORT___;
